/**
 * Validates a single RMS shipment line.
 * @param {*} line - The line to validate.
 * @returns {{ valid: boolean, issues: string[] }} - Empty issues array when valid.
 */
function validateShipmentLine (line) {
  if (!line || typeof line !== 'object') {
    return { valid: false, issues: ['not an object'] }
  }

  const issues = []
  const { productId, quantity } = line

  if (!productId) issues.push('missing productId')
  if (!Number.isFinite(quantity)) {
    issues.push('quantity is not a number')
  } else if (quantity <= 0) {
    issues.push(`quantity must be > 0 (got ${quantity})`)
  }

  return { valid: issues.length === 0, issues }
}

module.exports = { validateShipmentLine }
